import { colorTheme, textTheme } from "@milestone/component-library";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 35px;
  width: max-content;
`;

export const Header = styled.h4`
  ${textTheme.h4};
  color: ${colorTheme.black};
  margin: 0;
  padding: 0;
  padding-top: 20px;
`;

export const TopSaveWrapper = styled.div`
  position: absolute;
  right: -0px;
  top: -35px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-content: start;
  gap: 20px;
  width: 436px;
`;

export const DateWrapper = styled.div`
  margin-top: 10px;
`;

export const InputContainer = styled.div``;

export const Label = styled.label`
  ${textTheme.subtitle2};
  color: ${colorTheme.black};
  margin-bottom: 10px;
`;

export const ErrorWrapper = styled.span`
  margin: 6px;
  color: ${colorTheme.red};
`;

export const ChildContainer = styled(Section)`
  background: ${colorTheme.white};
  border: 1px solid rgba(195, 203, 205, 0.35);
  box-sizing: border-box;
  border-radius: 10px;
  padding: 20px;
  min-width: 476px;
`;

export const ChildWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
`;

export const Icon = styled.img`
  padding-left: 5px;
`;
